/**
 * @generated SignedSource<<57a0638f1a301a871d29175057bed2b7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type HelpCenterType = "ADVANCED" | "BASIC" | "CUSTOMER_SERVICE" | "HELP_HUB" | "UNIFIED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type CustomerExperiencesList_currentCustomerExperience$data = {
  readonly helpCenter: {
    readonly currentCustomerExperience?: {
      readonly __typename: "HelpCenter";
      readonly id: string;
      readonly type: HelpCenterType | null;
      readonly " $fragmentSpreads": FragmentRefs<"CustomerExperienceMenuContent_helpCenter">;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
  };
  readonly " $fragmentType": "CustomerExperiencesList_currentCustomerExperience";
};
export type CustomerExperiencesList_currentCustomerExperience$key = {
  readonly " $data"?: CustomerExperiencesList_currentCustomerExperience$data;
  readonly " $fragmentSpreads": FragmentRefs<"CustomerExperiencesList_currentCustomerExperience">;
};

import CustomerExperiencesListRefetchQuery_graphql from './CustomerExperiencesListRefetchQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentCustomerExperienceAri"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchCurrentCustomerExperience"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "fragmentPathInResult": [],
      "operation": CustomerExperiencesListRefetchQuery_graphql
    }
  },
  "name": "CustomerExperiencesList_currentCustomerExperience",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          }
        ],
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "condition": "fetchCurrentCustomerExperience",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "currentCustomerExperience",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "helpCenterAri",
                    "variableName": "currentCustomerExperienceAri"
                  }
                ],
                "kind": "LinkedField",
                "name": "helpCenterById",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": {
                          "kind": "ScalarField",
                          "name": "id"
                        },
                        "action": "THROW"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "type"
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "CustomerExperienceMenuContent_helpCenter"
                      }
                    ],
                    "type": "HelpCenter"
                  }
                ]
              }
            ]
          }
        ]
      },
      "action": "THROW"
    }
  ],
  "type": "Query"
};

(node as any).hash = "a6ab31f88287b0373d7a9c77af235b6f";

export default node;
